/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccE2eFixtureResetResponse
 */
export interface PccE2eFixtureResetResponse {
    /**
     * 
     */
    message?: string;
}

/**
 * Check if a given object implements the PccE2eFixtureResetResponse interface.
 */
export function instanceOfPccE2eFixtureResetResponse(value: object): value is PccE2eFixtureResetResponse {
    return true;
}

export function PccE2eFixtureResetResponseFromJSON(json: any): PccE2eFixtureResetResponse {
    return PccE2eFixtureResetResponseFromJSONTyped(json, false);
}

export function PccE2eFixtureResetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccE2eFixtureResetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function PccE2eFixtureResetResponseToJSON(json: any): PccE2eFixtureResetResponse {
    return PccE2eFixtureResetResponseToJSONTyped(json, false);
}

export function PccE2eFixtureResetResponseToJSONTyped(value?: PccE2eFixtureResetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

